import { useEffect, useState } from "react";
import { format, addDays, startOfDay } from "date-fns";
import { Calendar } from "@/components/ui/calendar";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";

const iso = (d) => format(d, "yyyy-MM-dd");

export default function SlotPicker({ date, time, onDate, onTime, serviceId }) {
  const { settings, state, t } = useApp();
  const [slots, setSlots] = useState(null);
  const today = startOfDay(new Date());
  const last = addDays(today, settings.booking_days_ahead);
  const jsToMon = (d) => (d.getDay() + 6) % 7;
  const svcId = serviceId || state.form.service_id;

  const disabled = (d) =>
    d < today || d > last || settings.holidays.includes(iso(d)) || !(settings.weekly_hours[String(jsToMon(d))] || []).length;

  useEffect(() => {
    if (!date || !svcId) return;
    setSlots(null);
    api
      .get("/slots", { params: { date, service_id: svcId } })
      .then((r) => setSlots(r.data.slots))
      .catch(() => setSlots([]));
  }, [date, svcId]);

  return (
    <div className="grid gap-5 md:grid-cols-[auto,1fr]">
      <div className="rounded-2xl border border-white/10 bg-black/20" data-testid="date-calendar">
        <Calendar
          mode="single"
          selected={date ? new Date(`${date}T00:00:00`) : undefined}
          onSelect={(d) => d && onDate(iso(d))}
          disabled={disabled}
          fromDate={today}
          toDate={last}
          className="text-emerald-50"
        />
      </div>
      <div>
        {!date && <p className="text-sm text-emerald-100/60">{t("pickDateFirst")}</p>}
        {date && slots === null && <div className="h-24 animate-pulse rounded-xl bg-white/5" />}
        {date && slots?.filter((s) => s.available).length === 0 && (
          <p className="text-sm text-amber-200/90" data-testid="no-slots-msg">{t("noSlots")}</p>
        )}
        <div className="grid grid-cols-3 gap-2 sm:grid-cols-4" data-testid="slot-grid">
          {slots?.map((s) => (
            <button
              key={s.time}
              type="button"
              disabled={!s.available}
              data-testid={`slot-${s.time}`}
              onClick={() => onTime(s.time)}
              className={`h-10 rounded-xl border text-sm transition-colors ${
                !s.available
                  ? "cursor-not-allowed border-white/5 text-emerald-100/25 line-through"
                  : time === s.time
                    ? "border-amber-300 bg-amber-300 text-emerald-950"
                    : "border-emerald-300/25 bg-black/20 text-emerald-50 hover:border-emerald-300/60"
              }`}
            >
              {s.time}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
